import { IconButton, makeStyles, Grid } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { prettyDate, to_YYYYMMDDHHMMSS } from '../../../config/dateFormatting';
import { FrontendApi } from '../../../planEatApi/FrontendApi';
import { ICheckInBooking } from '../../../interface/interface';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { IBookingContent, ISeatingContent, IVersionedObject } from '../../../planEatApi/PlanEatFacade';
import { CustomCheckBox } from '../../../components/ui/CustomCheckBox';
import { OfficeContext } from '../../../config/Context';
import { DateCarousel } from '../../../components/ui/DateCarousel';
import toast from 'react-hot-toast';
import { MdClose } from 'react-icons/md';
import clsx from 'clsx';
import { useAdminDateQueryParam } from '../../../hooks/useAdminDateQueryParam';


const useStyles = makeStyles((theme: any) => ({
    seatingContainer: {
        cursor: 'pointer',
        padding: 13,
        flexGrow: 1,
        marginRight: 20,
        marginTop: 18,
        marginBottom: 10,
        background: 'rgba(255, 255, 255, 0.7)',
        borderRadius: 8,
        height: 70,
        "&:last-child": {
            marginRight: 0
        }
    },
    checkInContainer: {
        display: 'grid',
        gridTemplateColumns: '70% 30%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: "0 0 8px 8px",
        minHeight: 400,
        padding: 30
    },
    stillToCheckInContainer: {
        borderRight: '1px dashed rgba(11, 37, 89, 0.2);',
        marginRight: 30,
        paddingRight: 30,
    },
    stillToCheckInTitleContainer: {
        display: 'flex',
        float: 'left',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: "fit-content",
        columnGap: 3
    },
    stillToCheckInListContainer: {
        paddingTop: 20
    },
    checkedInTitleContainer: {
        display: 'flex',
        float: 'left',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 80
    },
    noSeatingsContainer: {
        fontSize: 18,
        fontWeight: 700,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#FFFFFF',
        height: '60vh',
        color: '#AAAAAA',
        margin: 'auto',
        marginTop: 18,
        borderRadius: '8px 8px 0px 0px',
    },
    noBookingsOnSeating: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#FFFFFF',
        height: '60vh',
        color: '#AAAAAA',
        margin: 'auto',
        borderRadius: "0 0 8px 8px"
    },
    notCheckedInContainer: {
        display: 'grid',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: 5,
        gridTemplateColumns: '90% 10%',
        cursor: 'pointer',
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);',
        height: 50,
        width: '100%',
    },
    checkInParagraphs: {
        display: 'flex',
        maxWidth: "90%",
        minWidth: "90%",
        float: 'left',
        "& > *": {
            paddingRight: 5,
            margin: 0,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        }
    },
    checkBoxContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%'
    },
    multiUncheckContainerItem: {
        display: 'flex',
        flexDirection: 'row',
        minWidth: '100%',
        justifyContent: 'start',
    },
    multiUncheckedVerticalLine: {
        marginLeft: 5,
        borderRight: '1px solid #CCCCCC;',
        minHeight: '100%',
        "&:last-child": {
            height: '50%',
        }
    },
    multiUncheckedHorizontalLine: {
        height: 25,
        borderBottom: '1px solid #CCCCCC;',
        width: 15,
    },
    multiUncheckBorderBottom: {
        width: 'auto',
        marginLeft: 25,
    },
    multiUncheckHeaderContainer: {
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: 'auto',
        height: 50,
    },
    checkedBookingsContainer: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: '100%',
        justifyContent: 'start',
        marginTop: 20,
    },
    checkBookingItemContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 12,
        height: 30,
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);',
    },
    selectedStyle:{
        background: '#FFFFFF',
        borderRadius: '8px 8px 0px 0px',
        boxShadow: '0px 10px 0px #FFFFFF',
        cursor: 'pointer',
    }
}));

interface RouteParams {
    seatingId: string
}

export const AdminCheckIn: React.FC<RouteParams> = ({ }) => {
    // Styling
    const classes = useStyles();

    // Routing 
    let location = useLocation();

    // State
    const [date, setDate] = useState<Date>(new Date);

    const [seatingsView, setSeatingsView] = useState<any[]>([]);
    const [selectedSeating, setSelectedSeating] = useState<IVersionedObject<ISeatingContent>>();
    const [searchSeatingId, setSearchSeatingId] = useState<string>('');
    const [seatingsOnDate, setSeatingsOnDate] = useState<IVersionedObject<ISeatingContent>[]>([]);
    const [selectedSeatingOnDate, setSelectedSeatingOnDate] = useState<IVersionedObject<ISeatingContent>>();
    
    const [bookingsOnSeating, setBookingsOnSeating] = useState<IVersionedObject<IBookingContent>[]>([]);
    const [bookingsOnSeatingView, setBookingsOnSeatingView] = useState<any[]>([]);

    const [unCheckedBookings, setUnCheckedBookings] = useState<ICheckInBooking[]>([]);
    const [checkedBookings, setCheckedBookings] = useState<ICheckInBooking[]>([]);

    // Context
    const officeContext = useContext(OfficeContext);

    // Entities
    const [seatings,setSeatings] = useState<IVersionedObject<ISeatingContent>[]>([]);

    /* Update local date if global different than today */
    useAdminDateQueryParam(date,setDate)

    async function getDatabase(){
        await planEatApi.getSeatings().then((response) => {setSeatings(response.data)}).catch((e) => {console.log(e)})

        if(officeContext?.office){
            if (searchSeatingId=== '') {
                let tmpSearchSeatingId = new URLSearchParams(location.search).get("seatingId");
                if (tmpSearchSeatingId) {
                    setSearchSeatingId(tmpSearchSeatingId)
                    getDateOfSeatingId(tmpSearchSeatingId)
                } else {
                    getSeatingsOnDate(officeContext?.office.content.id);
                }
            } else {
                getSeatingsOnDate(officeContext?.office.content.id);
            }
        }
    }

    useEffect(() => {
        getDatabase()
    },[officeContext, date])

    // Get seatings + date based on seatingsId
    async function getDateOfSeatingId(tmpSeatingId: string) {
        setDate(await FrontendApi.getDateOfSeatingId(tmpSeatingId))
    }

    async function getSeatingsOnDate(officeId:string) {
        setSeatingsOnDate(await FrontendApi.getSeatingsOnDate(date,officeId,seatings))
    }

    // Check if seatingId already selected
    useEffect(() => {
        if (seatingsOnDate.length > 0) {
            setSelectedSeating(getSelectedSeating());
        } else {
            displaySeatings();
            displayBookings();
        }
    }, [seatingsOnDate]);

    function getSelectedSeating() {
        if (searchSeatingId=== '') {
            return seatingsOnDate[0]
        } else {
            let indexOfSeating = 0;
            seatingsOnDate.forEach((seatingOnDate, index) => {
                if (seatingOnDate.content.id=== searchSeatingId) {
                    indexOfSeating = index;
                }
            })
            return seatingsOnDate[indexOfSeating];
        }
    }

    useEffect(() => {
        displaySeatings();
        getBookingsOnSeating();
    }, [selectedSeating]);


    function displaySeatings() {
        const tmpDishesBookedView = seatingsOnDate.map((seatingOnDate, index) => (
            <Grid key={seatingOnDate.content.id} item className={clsx(classes.seatingContainer,seatingOnDate=== selectedSeating && classes.selectedStyle)} onClick={() => setSelectedSeating(seatingOnDate)}>
                <div style={{fontSize: 22}}>
                    {prettyDate(seatingOnDate.content.seatingStart, true, false)}
                </div>
                <div style={{fontSize: 12, fontWeight: "bold"}}>
                    {seatingOnDate.content.seatingName}
                </div>
            </Grid>
        ));
        setSeatingsView(tmpDishesBookedView);
    }

    async function getBookingsOnSeating() {
        if (selectedSeating) {
            setBookingsOnSeating(await FrontendApi.getBookingsOnSeating(selectedSeating.content.id))
        }
    }

    useEffect(() => {
        getUnCheckBookings();
    }, [bookingsOnSeating]);

    const getUnCheckBookings = async () => {
        setUnCheckedBookings(await FrontendApi.getUnCheckedBookings(bookingsOnSeating));
        setCheckedBookings(await FrontendApi.getCheckedBookings(bookingsOnSeating));
    }

    useEffect(() => {
        if (unCheckedBookings && checkedBookings) {
            displayBookings()
        }
    }, [unCheckedBookings, checkedBookings]);

    function checkInMultiBooking(booking: IVersionedObject<IBookingContent>) {
        booking.content.bookingItems.forEach((bookingItem) => {
            if (bookingItem.checkInTime=== undefined) {
                bookingItem.checkInTime = to_YYYYMMDDHHMMSS(new Date());
            }
        })

        planEatApi.postBooking(booking.content)
        .then(response => {
            toast.success("Check-in complete")
            getUnCheckBookings();
        })
        .catch(e => {
            toast.error("Check-in Check in was not complete")
        })
    }

    function checkInSinlgeBooking(booking: IVersionedObject<IBookingContent>, bookingItemId: string) {
        booking.content.bookingItems.forEach((bookingItem) => {
            if (bookingItem.bookingItemId=== bookingItemId) {
                bookingItem.checkInTime = to_YYYYMMDDHHMMSS(new Date());
            }
        })

        planEatApi.postBooking(booking.content)
        .then(response => {
            toast.success("Check-in complete")
            getUnCheckBookings();
        })
        .catch(e => {
            toast.error("Check-in Check in was not complete")
        })
    }

    function unCheckbooking(booking: IVersionedObject<IBookingContent>, bookingItemId: string){
        booking.content.bookingItems.forEach((bookingItem) => {
            if (bookingItem.bookingItemId=== bookingItemId) {
                bookingItem.checkInTime = undefined;
            }
        })

        planEatApi.postBooking(booking.content)
        .then(response => {
            toast.success("Booking unchecked")
            getUnCheckBookings();
        })
        .catch(e => {
            toast.error("Booking was not unchecked")
        })
    }

    function displayBookings(){
        if (seatingsOnDate.length > 0) {
            let numberOfUncheckedBookings = 0;
            let numberOfCheckedBookings = 0;
            let tmpNotCheckedIn: any[] = [];

            if (unCheckedBookings.length > 0) {
                unCheckedBookings.forEach((unCheckInBooking,globalIndex) => {
                    numberOfUncheckedBookings += unCheckInBooking.checkInBookingItems.length;
                    if (unCheckInBooking.checkInBookingItems.length=== 1) {
                        tmpNotCheckedIn.push(
                            <div key={unCheckInBooking.booking.content.id} className={classes.notCheckedInContainer} onClick={() => { checkInSinlgeBooking(unCheckInBooking.booking, unCheckInBooking.checkInBookingItems[0].bookingItemId) }}   >
                                <div className={classes.checkInParagraphs}>
                                    <b>{unCheckInBooking.eaterGroupName}</b> <p>{unCheckInBooking.eaterName}</p> <p>|</p> <p>{unCheckInBooking.checkInBookingItems[0].dishTitle}</p>
                                </div>
                                <div className={classes.checkBoxContainer}>
                                    <CustomCheckBox selected={false} />
                                </div>
                            </div>
                        )
                    } else if (unCheckInBooking.checkInBookingItems.length > 1) {
                        var tmpMultiUnCheckedList: any[] = []

                        tmpMultiUnCheckedList.push(
                            <div className={classes.multiUncheckHeaderContainer} onClick={() => { checkInMultiBooking(unCheckInBooking.booking) }}   >
                                <div key={unCheckInBooking.booking.content.id} className={classes.notCheckedInContainer} style={{ 'border': '0' }}>
                                    <div className={classes.checkInParagraphs}>
                                        <b>{unCheckInBooking.eaterGroupName} x {unCheckInBooking.checkInBookingItems.length}</b>
                                    </div>
                                    <div className={classes.checkBoxContainer}>
                                        <CustomCheckBox selected={false} />
                                    </div>
                                </div>
                                <div className={classes.multiUncheckBorderBottom} />
                            </div>
                        )
                        unCheckInBooking.checkInBookingItems.forEach((unCheckBookingItem, index) => {
                            tmpMultiUnCheckedList.push(
                                <div className={classes.multiUncheckContainerItem} key={unCheckBookingItem.bookingItemId} onClick={() => { checkInSinlgeBooking(unCheckInBooking.booking, unCheckBookingItem.bookingItemId) }}   >
                                    <div className={classes.multiUncheckedVerticalLine} style={index=== unCheckInBooking.checkInBookingItems.length - 1 ? { 'height': '25px' } : undefined} />
                                    <div className={classes.multiUncheckedHorizontalLine} />

                                    <div key={unCheckInBooking.booking.content.id} className={classes.notCheckedInContainer} style={{ 'borderTop': index=== 0 ? '1px dashed rgba(11, 37, 89, 0.2)' : undefined, 'borderBottom': index=== unCheckInBooking.checkInBookingItems.length - 1 ? '0px dashed rgba(11, 37, 89, 0.2)' : undefined }}>
                                        <div className={classes.checkInParagraphs}>
                                            <b>{unCheckInBooking.eaterGroupName}</b> <p>{unCheckInBooking.eaterName}</p> <p>|</p> <p>{unCheckInBooking.checkInBookingItems[index].dishTitle}</p>
                                        </div>
                                        <div className={classes.checkBoxContainer}>
                                            <CustomCheckBox selected={false} />
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        tmpNotCheckedIn.push(<div style={{ 'borderBottom': '1px dashed rgba(11, 37, 89, 0.2)' }}>{tmpMultiUnCheckedList}</div>)
                    }
                })
            } else {
                tmpNotCheckedIn = []
            }

            let tmpCheckedIn: any[] = [];
            if (checkedBookings.length > 0) {
                checkedBookings.forEach((checkedBooking) => {
                    numberOfCheckedBookings += checkedBooking.checkInBookingItems.length;
                    checkedBooking.checkInBookingItems.forEach((checkInBookingItem) => {
                        if (checkInBookingItem.checkInTime !== undefined) {
                            tmpCheckedIn.push(
                                <div className={classes.checkBookingItemContainer}>
                                    <div className={classes.checkInParagraphs}>
                                        <b>{checkedBooking.eaterGroupName}</b> <p>{checkedBooking.eaterName}</p> <p>|</p> <p>{checkInBookingItem.dishTitle}</p> <p>|</p> <i>Checked-in {prettyDate(checkInBookingItem.checkInTime, true, false)}</i>
                                    </div>
                                    <div>
                                        <IconButton style={{ 'padding': '3px' }} onClick={() => { unCheckbooking(checkedBooking.booking, checkInBookingItem.bookingItemId) }}>
                                            <MdClose />
                                        </IconButton>
                                    </div>
                                </div>
                            )
                        }
                    })
                })
            } else {
                tmpCheckedIn = []
            }

            const checkInView: any = (
                <div>
                    {bookingsOnSeating.length > 0 ?
                        <div>
                            <div className={classes.checkInContainer}>
                                <div className={classes.stillToCheckInContainer}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <div style={{fontSize: 18,fontWeight: "bold"}}>Stil to check in</div>
                                        <div className={classes.stillToCheckInTitleContainer}>
                                            <div style={{fontSize: 18,fontWeight: "bold"}}>
                                                {numberOfUncheckedBookings}
                                            </div>
                                            <div style={{fontSize: 12}}>
                                                out of
                                            </div>
                                            <div style={{fontSize: 18,fontWeight: "bold"}}>
                                                {numberOfCheckedBookings + numberOfUncheckedBookings}
                                            </div>
                                            <div style={{fontSize: 12}}>
                                                remaining
                                            </div>
                                        </div>
                                    </Grid>
                                    <div className={classes.stillToCheckInListContainer}>
                                        {tmpNotCheckedIn}
                                    </div>
                                </div>
                                <div>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <div style={{fontSize: 18,fontWeight: "bold"}}>Check-In</div>
                                        <div className={classes.checkedInTitleContainer}>
                                            <div style={{fontSize: 18,fontWeight: "bold"}}>
                                                {numberOfCheckedBookings}
                                            </div>
                                            <div style={{fontSize: 18}}>
                                                /
                                            </div>
                                            <div style={{fontSize: 18}}>
                                                {numberOfCheckedBookings + numberOfUncheckedBookings}
                                            </div>
                                        </div>
                                    </Grid>
                                    <div className={classes.checkedBookingsContainer}>
                                        {tmpCheckedIn}
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className={classes.noBookingsOnSeating}>No bookings on the selected seating</div>
                    }
                </div>
            );
            setBookingsOnSeatingView(checkInView);
        } else {
            const tmpNoSeatingsOnDate: any = ([]);
            setBookingsOnSeatingView(tmpNoSeatingsOnDate)
        }
    }
    // TODO - remove planeat text
    let indexChildSelected: number = 0;
    seatingsOnDate.forEach((seatingOnDate, index) => {
        if (seatingOnDate=== selectedSeatingOnDate) {
            indexChildSelected = index
        }
    })

    return (
        <div>
            <DateCarousel date={date} setDate={setDate}/>
            <div>
                {seatingsOnDate.length > 0 ?
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-evenly"
                        alignItems="center"
                    >
                        {seatingsView}
                    </Grid>
                    :
                    <div className={classes.noSeatingsContainer} >No seatings on the date</div>
                }
            </div>
            <div>
                {bookingsOnSeatingView}
            </div>
        </div>
    );
}